import moment from "moment";
import shmuhelper from "./shmu-helper";

export default
{
    legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        borderWidth: 0,
        useHTML:true
    },
    credits: {
        enabled:false
    },
    chart: {
        type: 'line',
        animation: false,
        height: '500px',
        spacingBottom: 0,
        spacingTop: 0,
        spacingLeft: 0,
        spacingRight: 10,

    },
    title: {
        text: 'M-dennosť priemerných denných prietokov',
        style: { fontSize:'14px' },
    },
    subtitle: {
        text: null
    },
    xAxis: {
        type: 'datetime',
        tickInterval: 30 * 24 * 3600 * 1000,
        dateTimeLabelFormats: {day: '%e. %b.'},
        tickWidth: 1,  gridLineWidth: 1,
        labels:{ style: { fontSize:'11px' },   rotation: 45, x:0, y:12},
        gridLineDashStyle: 'Dot',
        lineWidth: 2,
        crosshair: false,
        gridLineColor: 'rgba(200,200,200,0.8)',
        plotLines: []


    },
    yAxis: {
        title: {
            text: ' '
        },
        plotLines: [],
        labels: {
            enabled:false
        },
        minorTickInterval: 100,
        minorGridLineWidth:1,
        minorGridLineColor: 'rgba(200,200,200,0.2)',
        gridLineColor: 'rgba(200,190,160,0.6)'

    },
    tooltip: {
        valueSuffix: ' m<sup>3</sup>/s',
        shared:true,
        crosshairs:false,
        xDateFormat: '%d.%m.%Y',
        useHTML: true,
        formatter: function() {
            var s = '<b>' + moment(this.x).format("DD.MM.YYYY") + '</b><br><table class="tt_noborder">';
            this.points.forEach(item => {
                    var val = item.y + ' m<sup>3</sup>/s';
                    if (item.series.userOptions.id === 'dpr') {
                        val = shmuhelper.find_in_m_data(item.series.userOptions.md_data,
                            moment(this.x).unix(),
                            item.y, ' m<sup>3</sup>/s'
                        );
                    }

                    s += '<tr><td class="t-r"><span style="color:' + item.series.color + '">' + item.series.userOptions.shortname + ' </span></td><td><b>' + val + '</b></td></tr>';
                });
            s += '</table>';
            return s;


        },

    },
    plotOptions: {
        line: {
            connectNulls: false,
            animation: false,
            shadow: true,
            states: {
                hover: {
                    lineWidthPlus: 0
                }
            }

        },
        area: {
            connectNulls: false,
            animation: false,
            marker: {
                enabled: false,
                states: {
                    hover: {
                        enabled: false
                    }
                }
            },
            states: {
                hover: {
                    lineWidthPlus: 0
                }
            }


        },
        states:{
            hover:{
                enabled:true
            }
        },
        series: {
            states:{
                inactive: {
                    opacity: 1
                }
            },

        }
    },
    series: [
        {"id":"dpr",
            "shortname":"Qd",
            "showInLegend":false,
            "name": "Qd – priemerné denné prietoky aktuálneho roku",
            "color":"#05FA67",
            "lineWidth":3,
            "data": []
        }
    ]
}